import React, {Component} from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import './App.css';
import Atharo from './Atharo'
import Login from './Login'
import JobsPage from './JobsPage/JobsPage'
import Axios from 'axios';
import AdminMaster from './AdminMaster/AdminMaster'
import { ApolloProvider, ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import NewStudentFormWithSecurity from './NewStudentForm/NewStudentFormWithSecurity';
import NewStudentFormTwo from './NewStudentForm/NewStudentFormTwo/NewStudentFormTwo';
import TeacherPortal2021 from './TeacherPortal2021/TeacherPortal2021';
import ReviewForm from './ReviewForm/ReviewForm'
import {baseUrl} from './assets/Animations'

class App extends Component {
  constructor() {
    super()
    this.state = {
      user: null,
      userData: {},
      adminConversations: [],
      openedConversation: null,
      anythingUnread: false,
      unreadMessageRooms: [],
      subdomainName: '',
      applications: [],
      familiesToWatch: [],
      moreAttentionFamilies: []
    }
  }


  componentDidMount = async () => {
    this.setTheSchool()
    let accessToken = localStorage.getItem('token');
    let email = localStorage.getItem('user')
    if(accessToken) {
      const myToken = localStorage.getItem('token')
      const myHeader = {
          headers: { Authorization: `Bearer ${myToken}` }
      }
      //console.log(myHeader)
      Axios.get(`${baseUrl}/data/${email}`, myHeader)
      .then((res) => {
        this.setState({
          userData: res.data,
          user: res.data.Email
        })
      })
      .catch((err) => {
        console.log(err)
      })
    }
  }

  getLastPart(url) {
    var parts = url.split("/");
    return (url.lastIndexOf('/') !== url.length - 1 
       ? parts[parts.length - 1]
       : parts[parts.length - 2]);
  }

  setTheSchool = () => {
    let url = window.location.href
    let trimmed = url.substring(8)
    let name = trimmed.split('.')[0]
        this.setState({subdomainName: name})
  }

  onLoggedIn = (authData) => {
      //this.getTeacherInfo(authData.token, authData.user.Email)
      localStorage.setItem('token', authData.token)
      localStorage.setItem('user', authData.user.Email)
      this.setState({
        userData: authData.user,
        user: authData.user.Email
      })
  }

  getApplications = async () => {
      let myToken = localStorage.getItem('token')
      let myHeader = {
          headers: { Authorization: `Bearer ${myToken}` }
      }
      Axios.get(`${baseUrl}/applications`, myHeader)
      .then(response => {
        this.setState({
          applications: response.data
        })
      })
      .catch(e => {
          console.log('YIKES ' + e)
          console.log(e)
      })
  }
  getFamiliesToWatch = async () => {
    let myToken = localStorage.getItem('token')
    let myHeader = {headers: { Authorization: `Bearer ${myToken}` }}
    Axios.get(`${baseUrl}/families-to-watch`, myHeader)
    .then(response => {
      this.setState({
        familiesToWatch: response.data
      })
    })
    .catch(e => {
      console.log(e)
    })
    Axios.get(`${baseUrl}/school-management/more-attention`, myHeader)
    .then(response => {
      this.setState({
        moreAttentionFamilies: response.data
      })
    })
    .catch(e => {
      console.log(e)
    })
  }

  removeApplication = (id) => {
    let myApplications = this.state.applications
    for(let i = 0; i < myApplications.length; i++) {
      if(myApplications[i].id === id) {
        myApplications.splice(i, 1)
      }
    }
    this.setState({
      applications: myApplications
    })
  }

  logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    window.location.reload()
  }






  render() {
    let { user } = this.state
    let { userData } = this.state


    const httpLink = createHttpLink({
      uri: 'https://gql.waveapps.com/graphql/public',
    });
    
    const authLink = setContext((_, { headers }) => {
      return {
        headers: {
          ...headers,
          authorization: `Bearer 6jdTcRqxxC8fimWfzDm5ZN9c3TNr4b`,
        }
      }
    });
    
    const client= new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache()
    })



    return (
      <ApolloProvider client={client}>
        <Router>
          <Switch>
            <Route path={'/'} exact component={Atharo} />
            <Route path={'/newstudentform'} exact component={NewStudentFormTwo} />
            {/* <Route path={'/newformtest'} exact component={NewStudentFormTwo} /> */}
            <Route path={'/newstudentform/:familyId'} exact component={NewStudentFormWithSecurity} />
            <Route path={'/providers/:school/:instrument/review'} exact component={ReviewForm} />
            <Route path={'/admin'} exact render={() => {
              if (!user) return <Login accessPoint={'admin'} onLoggedIn={user => this.onLoggedIn(user)} logConvos={this.logConvos} />;
              return userData.School === 'admin' && <AdminMaster 
                                                        userData={userData}
                                                        logout={() => this.logout()}
                                                        user={user}
                                                        adminConversations={this.state.adminConversations}
                                                        openedConversation={this.state.openedConversation}
                                                        chooseConversationToJoin={this.chooseConversationToJoin}
                                                        sendTheMessage={this.sendTheMessage}
                                                        appendAReceivedMessage={this.appendAReceivedMessage}
                                                        getJustTheMostRecentMessages={this.getJustTheMostRecentMessages}
                                                        disconnectFromSocket={this.disconnectFromSocket}
                                                        anythingUnread={this.state.anythingUnread}
                                                        setAnythingUnread={this.setAnythingUnread}
                                                        unreadMessageRooms={this.state.unreadMessageRooms}
                                                        markRoomAsRead={this.markRoomAsRead}
                                                        setUnreadFlag={this.setUnreadFlag}
                                                        applications={this.state.applications}
                                                        getApplications={this.getApplications}
                                                        familiesToWatch={this.state.familiesToWatch}
                                                        moreAttentionFamilies={this.state.moreAttentionFamilies}
                                                        getFamiliesToWatch={this.getFamiliesToWatch}
                                                        removeApplication={this.removeApplication}
                                                    />
            }} />
            <Route path={'/teacherportal'} exact render={() => {
              if (!user) return <Login accessPoint={'teacher'} onLoggedIn={user => this.onLoggedIn(user)} />;
              return <TeacherPortal2021 logout={() => this.logout()} userData={userData} user={user} />
            }} />
            <Route path={'/careers'} exact render={() => {
              return <JobsPage />
            }} />
            {/* <Route path={'/newteacherportal'} exact render={() => {
              return <TeacherPortal2021 userData={userData} logout={this.logout} />
            }} /> */}
          </Switch>
        </Router>
      </ApolloProvider>
    )
  }
} 

export default App;









































// class App extends Component {
//   constructor() {
//     super()
//     this.state = {
//       user: null,
//       userData: {},
//       adminConversations: [],
//       unreadMessage: [],
//       anythingUnread: false,
//       theNewMsg: null
//     }
//   }


//   componentDidMount = async () => {
//     let accessToken = localStorage.getItem('token');
//     let email = localStorage.getItem('user')
//     if (accessToken !== null) {
//       await this.getTeacherInfo(accessToken, email);
//     } else {
//       let endPoint = this.getLastPart(window.location.href)
//       if(endPoint === 'admin') {
//         this.getAllChatsFromApi()
//       }
//     }
//   }

//   getLastPart(url) {
//     var parts = url.split("/");
//     return (url.lastIndexOf('/') !== url.length - 1 
//        ? parts[parts.length - 1]
//        : parts[parts.length - 2]);
// }

//   componentDidUpdate = () => {
//     //LOG THE NEW MESSAGE
//     if(this.state.theNewMsg) {
//       this.logTheNewMessage(this.state.theNewMsg)
//       this.setTheNewMsg(null)
//     }
//   }

//   logTheNewMessage = (message) => {
//     let arrayToEdit = this.state.adminConversations
//     for(let i = 0; i < arrayToEdit.length; i++) {
//         if(arrayToEdit[i].RoomId === message.message.RoomId){
//             arrayToEdit[i].Messages.push(message.message)
//             this.logConvos(arrayToEdit)
//             if(message.message.Sender !== this.state.userData.Name) {
//               this.checkForUnreadMessages(arrayToEdit)
//             }
//         }
//     }
//     if(!message.message.ListOfReaders.includes(this.state.userData.Name)) {
//         let holder = this.state.unreadMessage
//         if(!holder.includes(message.message.RoomId)) {
//             holder.push(message.message.RoomId)
//             this.setUnreadMessage(holder)
//         }
//     }
// }


//   getAllChatsFromApi = async () => {
//     if (window.location.href.startsWith('http://localhost:3000')) {
//     return
//     } else {
//       let myToken = localStorage.getItem('token')
//       Axios.get('https://app.atharo.app/chats', {
//         headers: { Authorization: `Bearer ${myToken}` }
//       })
//       .then(response => {
//         this.logConvos(response.data)
//       })
//       .catch(err => {
//         console.log(err)
//       })
//     }
//   }

//   checkForUnreadMessages = (convos) => {
//     let unreadArray = this.state.unreadMessage
//     convos.forEach(convo => {
//       if(!convo.Messages[convo.Messages.length - 1].ListOfReaders.includes(this.state.userData.Name)) {
//           if(!unreadArray.includes(convo.RoomId)) {
//               unreadArray.push(convo.RoomId)
//           }
//       }
//     });
//     this.setState({
//       unreadMessage: unreadArray
//     }, () => {
//       this.checkForAnythingUnread()
//     })
//   }

//   checkForAnythingUnread = () => {
//     if(this.state.unreadMessage.length > 0) {
//       this.setState({
//         anythingUnread: true
//       })
//     } else {
//       this.setState({
//         anythingUnread: false
//       })
//     }
// }
//   setAnythingUnread = (bool) => {
//     this.setState({
//       anythingUnread: bool
//     })
//   }

//   setUnreadMessage = (msg) => {
//     this.setState({
//       unreadMessage: msg
//     })
//   }
//   setTheNewMsg = (msg) => {
//     this.setState({
//       theNewMsg: msg
//     })
//   }

//   disconnectFromSocket = () => {
//     socket.emit('disconnect', this.state.userData.Name)
//     socket.off = socket.removeListener;
//   }

//   componentWillUnmount = () => {
//     this.disconnectFromSocket()
//   }

//   getTeacherInfo = async (token, email) => {
//     localStorage.setItem('token', token)
//     localStorage.setItem('user', email)
//     Axios.get(`https://app.atharo.app/data/${email}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     })
//     .then(response => {
//       let endPoint = this.getLastPart(window.location.href)
//       if(endPoint === 'admin') {
//         joinARoom(response.data.Name, 'mma-chat')
//       }
//       this.setState({
//         userData: response.data,
//         user: localStorage.getItem('user')
//       }, () => {
//         let endPoint = this.getLastPart(window.location.href)
//         if(endPoint === 'admin') {
//           this.getAllChatsFromApi()
//         }
//       });
//     })
//     .catch(function (error) {
//       console.log(error)
//     })
//   }

//   logConvos = (convos) => {
//     let convoArray = []
//     for(let i = 0; i < convos.length; i++) {
//       if(this.state.userData.ChatRooms.includes(convos[i].RoomId)) {
//         convoArray.push(convos[i])
//       }
//     }
//     this.setState({
//       adminConversations: convoArray
//     }, () => {
//       this.checkForUnreadMessages(this.state.adminConversations)
//     })
//   }

//   onLoggedIn(authData) {
//     if (window.location.href.startsWith('http://localhost:3000')) {
//       this.setState({
//         user: authData.Email,
//         userData: authData
//       })
//     } else {
//       this.getTeacherInfo(authData.token, authData.user.Email)
//     }
//   }

//   finallySendAMessage = (msg) => {
//     socket.emit('sendMessage', msg)
//   }


//   logout = () => {
//     localStorage.removeItem('token')
//     localStorage.removeItem('user')
//     window.location.reload()
//   }





//   render() {
//     let { user } = this.state
//     let { userData } = this.state


//     const httpLink = createHttpLink({
//       uri: 'https://gql.waveapps.com/graphql/public',
//     });
    
//     const authLink = setContext((_, { headers }) => {
//       return {
//         headers: {
//           ...headers,
//           authorization: `Bearer 6jdTcRqxxC8fimWfzDm5ZN9c3TNr4b`,
//         }
//       }
//     });
    
//     const client= new ApolloClient({
//       link: authLink.concat(httpLink),
//       cache: new InMemoryCache()
//     })



//     return (
//       <ApolloProvider client={client}>
//         <Router>
//           <Switch>
//             <Route path={'/'} exact component={Atharo} />
//             <Route path={'/newstudentform'} exact component={NewStudentForm} />
//             <Route path={'/admin'} exact render={() => {
//               if (!user) return <Login accessPoint={'admin'} onLoggedIn={user => this.onLoggedIn(user)} logConvos={this.logConvos} />;
//               return userData.School === 'admin' && <AdminMaster 
//                                                         userData={userData}
//                                                         logout={() => this.logout()}
//                                                         user={user}
//                                                         finallySendAMessage={this.finallySendAMessage}
//                                                         adminConversations={this.state.adminConversations}
//                                                         logConvos={this.logConvos}
//                                                         disconnectFromSocket={this.disconnectFromSocket}
//                                                         setUnreadMessage={this.setUnreadMessage}
//                                                         unreadMessage={this.state.unreadMessage}
//                                                         setAnythingUnread={this.setAnythingUnread}
//                                                         anythingUnread={this.state.anythingUnread}
//                                                         checkForAnythingUnread={this.checkForAnythingUnread}
//                                                         setTheNewMsg={this.setTheNewMsg}
//                                                         getAllChatsFromApi={this.getAllChatsFromApi}
//                                                     />
//             }} />
//             <Route path={'/teacherportal'} exact render={() => {
//               if (!user) return <Login accessPoint={'teacher'} onLoggedIn={user => this.onLoggedIn(user)} />;
//               return <TeacherDashboard logout={() => this.logout()} userData={userData} user={user} />
//             }} />
//             <Route path={'/careers'} exact render={() => {
//               return <JobsPage />
//             }} />
//           </Switch>
//         </Router>
//       </ApolloProvider>
//     )
//   }
// }
  

// export default App;
